import { toolAppProps } from "../bars/utils";

export const headerTitleProps = {
  title: String,
  agent: String,
  member: String,
  showLogo: Boolean,
  showOnline: Boolean,
  site: String
};

export const headerProps = {
  ...headerTitleProps,
  ...toolAppProps,
  user: Object,
  marquee: String,
};
